export default function resizeIframe() {
  let frameHeight = document.documentElement.offsetHeight < 1000 ? 1000 : document.documentElement.offsetHeight + 50;

	window.parent.postMessage(
		{
			func: "resizeIframe",
			height: `${frameHeight}px`,
		},
		"*"
	);
}
